import {
  PLACEMENT_REVENUE_REPORT_REQUEST,
  PLACEMENT_REVENUE_REPORT_SUCCESS,
  PLACEMENT_REVENUE_REPORT_FAIL,
} from "./actionType";

export const getPlacementRevenueReport = (data) => ({
  type: PLACEMENT_REVENUE_REPORT_REQUEST,
  payload: data,
});

export const getPlacementRevenueReportSuccess = (data) => ({
  type: PLACEMENT_REVENUE_REPORT_SUCCESS,
  payload: data,
});

export const getPlacementRevenueReportFail = (error) => ({
  type: PLACEMENT_REVENUE_REPORT_FAIL,
  payload: error,
});
